// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdSupportAnsApi, AdSupportSgApi } from "_Route/Api";


const AdDevSupportDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();

  const sessionID = localStorage.getItem('memSessionID')
  const userName = useSelector(state => state.authorityAcc.name);
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);

  const [supportData, setSupportData] = useState();
  const [info, setInfo] = useState({
    request_uuid: params.id,
    request_res: userName,
    request_res_content: '',
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const { request_res_content } = info;
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm');

  
  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  // onChange Info
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  /*========================================================================
  * Dev Support Axios
  ========================================================================*/
  // 문의 내역 조회
  useEffect(() => {
    axios({
      url: AdSupportSgApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        request_uuid: params.id
      }
    })
    .then(res => {
      const curSp = res.data.result[0]
      if(curSp === undefined && params.id !== 'add') {
        navigate('/404');
      }
      setSupportData(curSp);
    })
    .catch(err => {
      console.error(err, "GET Support Request Data Error...");
    })
  }, [])


  // 문의 답변하기 
  const postSP = () => {
    if (request_res_content === '') { alert("답변 내용을 입력해주세요.") }
    else {
      axios({
        url: AdSupportAnsApi,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        data: info
      })
      .then(res => {
        alert(`문의 답변${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
        navigate('/admin/dev-support/list')
      })
      .catch(err => {
        console.error(err, `Support Request PUT Error..`)
        const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
      })
    }
  }

  
  return (
    <>
      <div className="adContTitGroup">
        <h2>문의 답변{supportData?.request_res_content ? ' 확인' : '하기'}</h2>
        <p>Home / Dev Support / 문의 답변{supportData?.request_res_content ? ' 확인' : '하기'}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>문의 답변</legend>


          {/* 문의 제목 [request_title] */}
          <div className="fieldGroup row">
            <label>문의 제목</label>

            <div className="field full">
              <input type="text" className="input md round_10" name="request_title" value={supportData?.request_title || ''} disabled />
            </div>
          </div>

          {/* 문의 내용 [request_content] */}
          <div className="fieldGroup row">
            <label>문의 내용</label>

            <div className="field full">
              <textarea type="text" className="textarea md round" name="request_content" value={supportData?.request_content || ''} disabled />
            </div>
          </div>

          {/* 답변 내용 [request_res_content] */}
          <div className="fieldGroup row">
            <label>답변 내용<span className="redTxt">*</span></label>

            <div className="field full">
              <textarea type="text" className="textarea md round" name="request_res_content" value={supportData?.request_res_content ?? request_res_content} onChange={(e) => onChange(e)} placeholder="답변 내용을 입력해주세요." disabled={supportData?.request_res_content ? true : false}/>
            </div>
          </div>

          {/* 처리자 */}
          <div className="fieldGroup row">
            <label>처리자</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={userName} disabled />
            </div>
          </div>

          {/* 처리 일시 */}
          <div className="fieldGroup row">
            <label>처리 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={supportData?.request_res_content ? moment(supportData.request_res_date).format('YYYY-MM-DD HH:mm') : curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= 200 && !supportData?.request_res_content &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={postSP}>{`답변 보내기${master === 1 ? '' : ' 요청'}`}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/dev-support/list')}>목록으로</button>
        </div>
      </div>
    </>
  )
}

export default AdDevSupportDt;